import { Alert } from 'order-status-banner/types/alert/alert'

export const getAlert = (alert?: Alert) =>
	alert
		? Object.values(Alert).find((alertValue) => alertValue === alert)
		: undefined
